const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowDialog', ['SettingsService', 'DialogRegistry', require('./dialog-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dialog/index.js
 **/